// extracted by mini-css-extract-plugin
export default {"container":"heading-nearshore-module--container--jqDia","title":"heading-nearshore-module--title--KQAdf"};